module.exports = __webpack_public_path__ + "media/loose+soso.5c1049af.mp3";